import { render } from "./ks-fs-view.vue?vue&type=template&id=f6e6a9f6"
import script from "./ks-fs-view.vue?vue&type=script&setup=true&lang=js"
export * from "./ks-fs-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/ks-fs-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6e6a9f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6e6a9f6', __exports__)) {
    api.reload('f6e6a9f6', __exports__)
  }
  
  module.hot.accept("./ks-fs-view.vue?vue&type=template&id=f6e6a9f6", () => {
    api.rerender('f6e6a9f6', render)
  })

}


export default __exports__